import React from 'react';
import { useAuth } from '../../context/AuthContext';
import Login from '../Auth/Login';
import Spinner from './Spinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center app-auth-loader">
        <div className="app-panel text-center px-5 py-4">
          <Spinner label="Loading your workspace..." />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return children;
};

export default ProtectedRoute;
